import { Button } from "@/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/DropdownMenu";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/AlertDialog";
import { Copy, MoreVertical, Pencil, Save, Trash2, X } from "lucide-react";
import { Dialog, DialogTrigger } from "@/components/ui/Dialog";
import React from "react";
import { useToast } from "@/components/ui/UseToast";
import { ErrorType } from "@/app/types";
import warning from "@/assets/warning.svg";
import { useDeleteDepartmentMutation } from "@/services/DepartmentApi";
import { Department } from "@/app/types/department";
import { WorkflowStatus } from "@/app/shared_enums/enums";
export function DataTableRowActions({
  data,
  refetch,
  handleEdit,
  access,
  updateStatus,
  duplicateWorkflow,
}: Readonly<{
  data: any;
  refetch?: any;
  handleEdit?: any;
  access: string;
  updateStatus?: any;
  duplicateWorkflow?: any;
}>) {
  const [isdelete, setIsDelete] = React.useState(false);
  const { toast } = useToast();
  const [deleteDepartment] = useDeleteDepartmentMutation();

  const deleteRow = async () => {
    try {
      const resp = await deleteDepartment({
        id: data?.id,
      } as Partial<Department>)
        .unwrap()
        .then((res) => {
          refetch();
          toast({
            variant: "success",
            title: "Department Deleted Successfully",
          });
        })
        .catch((error) => {
          toast({
            variant: "destructive",
            title: `Failed to Delete Department.${error?.data?.detail || error?.data?.message}`,
          });
        });
      return;
    } catch (error) {
      console.error("Error", { error });
      if (error && typeof error === "object" && "data" in error) {
        const typedError = error as ErrorType;
        toast({
          variant: "destructive",
          title: "Error in form Submission",
          description: `${typedError.data?.detail ?? (typedError.data as { message?: string }).message}`,
        });
      } else {
        toast({
          variant: "destructive",
          title: "Error in form Submission",
          description: `Something Went Wrong.`,
        });
      }
    }
  };

  return (
    <>
      <Dialog>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
            >
              <MoreVertical className="h-4 w-4" />
              <span className="sr-only">Open menu</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="">
            <DialogTrigger asChild>
              {//access == "write" &&
                [WorkflowStatus.Draft, WorkflowStatus.Active, WorkflowStatus.Inactive].includes(data?.status) && (
                  <DropdownMenuItem onClick={() => handleEdit(data)}>
                    <Pencil className="mr-2 h-4 w-4" />
                    Edit
                  </DropdownMenuItem>
                )}
            </DialogTrigger>
            {access == "write" && (
              <DropdownMenuItem onClick={() => setIsDelete(true)}>
                <Trash2 className="mr-2 h-4 w-4" />
                Delete
              </DropdownMenuItem>
            )}
            {//access == "write" &&
              [WorkflowStatus.Draft, WorkflowStatus.Inactive].includes(data?.status) && (
                <DropdownMenuItem onClick={() => updateStatus({ id: data?.id, status: WorkflowStatus.Active })}>
                  <Save className="mr-2 h-4 w-4" />
                  Active
                </DropdownMenuItem>
              )}
            {//access == "write" &&
              [WorkflowStatus.Active].includes(data?.status) && (
                <DropdownMenuItem onClick={() => updateStatus({ id: data?.id, status: WorkflowStatus.Inactive })}>
                  <Save className="mr-2 h-4 w-4" />
                  Inactive
                </DropdownMenuItem>
              )}
            {//access == "write" &&
              (
                <DropdownMenuItem onClick={() => duplicateWorkflow({ id: data?.id })}>
                  <Copy className="mr-2 h-4 w-4" />
                  Duplicate
                </DropdownMenuItem>
              )}
            {//access == "write" &&
              (
                [WorkflowStatus.Draft, WorkflowStatus.Active, WorkflowStatus.Inactive].includes(data?.status) && (
                  <DropdownMenuItem onClick={() => {
                    updateStatus({ id: data?.id, status: WorkflowStatus.Archived })
                  }}>
                    <X className="mr-2 h-4 w-4" />
                    Archive
                  </DropdownMenuItem>
                ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </Dialog>
      {isdelete && (
        <AlertDialog open={isdelete} onOpenChange={() => setIsDelete(false)}>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogDescription>
                <div className="flex flex-col items-start  justify-start gap-4">
                  <img src={warning} alt="warning" className="size-14" />
                  <AlertDialogTitle className="text-lg font-medium">
                    Are you sure you want to delete this Department? This action
                    cannot be undone.
                  </AlertDialogTitle>
                </div>
                <div className=" flex justify-end items-center gap-3 mt-4">
                  <AlertDialogCancel
                    onClick={() => setIsDelete(false)}
                    className="w-[100px] border border-primary font-semibold"
                  >
                    <i className="fa fa-xmark text-base px-1 "></i>
                    Cancel
                  </AlertDialogCancel>
                  <AlertDialogAction
                    onClick={deleteRow}
                    className="w-[100px] bg-primary !text-black font-semibold"
                  >
                    <i className="fa-regular fa-floppy-disk text-base px-1 "></i>
                    Delete
                  </AlertDialogAction>
                </div>
              </AlertDialogDescription>
            </AlertDialogHeader>
          </AlertDialogContent>
        </AlertDialog>
      )}
    </>
  );
}
